import { render, staticRenderFns } from "./ClinicCounterup.vue?vue&type=template&id=38e79c7c&"
import script from "./ClinicCounterup.vue?vue&type=script&lang=js&"
export * from "./ClinicCounterup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports